import Immutable from "immutable";
import serialize from "services/serialize";

const modalBillingCustomerMap = Immutable.Map({
  companyName: "",
  email: "",
  phoneNumber: "",
  isLoading: false,
  canSubmit: false
});

export const modalBillingCustomer = (
  state = modalBillingCustomerMap,
  action
) => {
  switch (action.type) {
    case "SET_MODAL_BILLING_CUSTOMER":

      return stateWithMetaData(state.merge(action.payload));

    case "GET_BILLINGS_SUCCESS": {
      const billingPlan = serialize(action.response.data.billing_plan);
      let newState = state;

      if (!billingPlan.size) {
        return state;
      }

      const customer = billingPlan.get("customer");

      newState = state.merge({
        companyName: customer.get("description", ""),
        email: customer.get("email", ""),
        phoneNumber: billingPlan.get("phoneNumber", "")
      });

      return stateWithMetaData(newState);
    }

    case "UPDATE_BILLING_CUSTOMER_REQUEST":
      return state.set("isLoading", true);
    case "UPDATE_BILLING_CUSTOMER_SUCCESS":
    case "UPDATE_BILLING_CUSTOMER_FAILURE":
      return state.set("isLoading", false);
    default:
      return state;
  }
};

/**
 *
 * @param {Immutable.Map} state
 * @returns {Immutable.Map} updated State
 */
function stateWithMetaData(state) {
  const canSubmit = Boolean(
    state.get("companyName") &&
    state.get("email")
  );

  return state.set("canSubmit", canSubmit);
}
